goog.provide('el8.app.settings.templates');

goog.require('el8.app.shared.dialog.createLabOrderTest');
goog.require('el8.appshared.listeditorOpts');
goog.require('el8.appshared.mindreaderOpts');
goog.require('el8.data.ancillaryCompanies');
goog.require('el8.data.checklistTemplates');
goog.require('el8.data.labOrderSets');
goog.require('el8.data.imos');
goog.require('el8.practicedata.letterTemplates');
goog.require('el8.template.appchart.dialog.order.lab');
goog.require('el8.template.app.settings.templates');
goog.require('el8.uiwidget.alert');
goog.require('el8.uiwidget.CollapsibleCuratedList');
goog.require('el8.util.consts');

el8.app.settings.templates = (function() {

    var that = {};

    that = {

        init: function($container) {

            // create initial frame
            var $content = $(el8.template.app.settings.templates.content({}));
            $container.html($content).show();

            el8.data.checklistTemplates.softLoad(function() {
                el8.data.checklistTemplates.sorted(); // enforce alpha-sort initially
                setupChecklistList('pe', $container);
                setupChecklistList('ros', $container);
            }, true);

            el8.practicedata.letterTemplates.softLoad(function() {
                // initially sort alphabetically ourselves,
                // then we'll let new items get added to the end
                el8.practicedata.letterTemplates.all().sort(function(a, b) {
                    return a.getName().localeCompare(b.getName());
                });
                setupLetterTemplateList($container);
            }, true);

        }

    };

    function errorMsgFn(status, defaultMsg, item) {
        if (status === 409) {
            el8.uiwidget.alert('This template name already exists. ' +
                'Please edit the existing template named "'+item.getName() +
                '" or pick a new name.');
        } else {
            el8.uiwidget.alert(defaultMsg);
        }
    }

    function expandFn($li) {
        $('.template-description-snippet', $li).hide();
    }
    function collapseFn($li) {
        $('.template-description-snippet', $li).show();
    }

    /* Checklist Templates */
    function setupChecklistList(checklistType, $container) {
        var defaultChecklist = el8.data.checklistTemplates.getDefaultByType(checklistType);
        // specifying 'N' for gender will make sure female-specific fields like "breast" get included
        var checklistFields = defaultChecklist ? defaultChecklist.getFieldNames('N') : [];
        var fieldSpec = [
            {
                name: 'name',
                maxLength: 30,
                selector: ':input[name="name"]',
                validate: {
                    required: true
                }
            }
        ];
        fieldSpec = fieldSpec.concat(checklistFields.map(function(fieldName) {
            return {
                name: fieldName,
                selector: ':input[name="'+fieldName+'"]',
                height: el8.util.consts.DEFAULT_FIELD_HEIGHT
                // text field: no maxLength needed
            };
        }));

        new el8.uiwidget.CollapsibleCuratedList({
            entitySet: el8.data.checklistTemplates,
            confirmDeletes: true,
            highlightNewEntries: true,
            itemDescriptionStr: 'checklist template',
            container: $('.'+checklistType+'-template-section', $container),
            listSelector: '.'+checklistType+'-template-list',
            sortable: false,
            expandFn: expandFn,
            collapseFn: collapseFn,
            listTemplateFn: function() {
                var unsortedTemplates = el8.data.checklistTemplates.allType(checklistType, true, true);
                return el8.template.app.settings.templates.checklistList({
                    checklistTemplates: unsortedTemplates.map(el8.model.toSoyMapFn)
                });
            },
            saveFn: function(form, $elem) {
                if (!form.isValid()) { return; }
                var checklist;
                var elemId = $elem.data('id');
                if (elemId) {
                    checklist = el8.data.checklistTemplates.getById(elemId);
                } else {
                    checklist = el8.data.checklistTemplates.create({type: checklistType}, true); // noNotify: re-render when saved
                }
                checklist.setName(form.getVal('name'));
                checklistFields.forEach(function(fieldName, index) {
                    checklist.setFieldByName(fieldName, form.getVal(fieldName), index);
                });

                var data = checklist.asMap();
                $.el8_ajax({
                    type: 'POST',
                    url: el8.service.urls.get('checklistTemplates', [checklist.getId()]),
                    data: JSON.stringify(data),
                    success: function(data) {
                        el8.data.checklistTemplates.create(data);
                    },
                    error_msg: function(status, defaultMsg) {
                        errorMsgFn(status, defaultMsg, checklist);
                    }
                });
            },
            formTemplateFn: function() {
                return el8.template.app.settings.templates.checklistForm({
                    choices: checklistFields
                });
            },
            formPopulateFn: function(form, checklist) {
                var itemMap = { name: checklist.getName() };
                $.extend(itemMap, checklist.asObj()); // asObj gets the fields as a dictionary
                form.populate(itemMap);
            },
            fieldSpec: fieldSpec
        }).init();
    }

    /* Letter Templates */
    function setupLetterTemplateList($container) {
        new el8.uiwidget.CollapsibleCuratedList({
            entitySet: el8.practicedata.letterTemplates,
            confirmDeletes: true,
            highlightNewEntries: true,
            itemDescriptionStr: 'letter template',
            container: $('.letter-template-section', $container),
            listSelector: '.letter-template-list',
            sortable: false,
            expandFn: expandFn,
            collapseFn: collapseFn,
            listTemplateFn: function() {
                return el8.template.app.settings.templates.letterTemplateList({
                    letterTemplates: el8.practicedata.letterTemplates.allAsSoyMaps()
                });
            },
            formTemplateFn: el8.template.app.settings.templates.letterTemplateForm,
            fieldSpec: [
                {
                    name: 'name',
                    selector: ':input[name="name"]',
                    validate: {
                        required: true
                    }
                },
                {
                    name: 'subject',
                    selector: ':input[name="subject"]',
                    height: el8.util.consts.DEFAULT_FIELD_HEIGHT,
                    maxLength: 200
                },
                {
                    name: 'body',
                    selector: ':input[name="body"]',
                    height: el8.util.consts.DEFAULT_FIELD_HEIGHT*4
                }
            ]
        }).init();
    }

    return that;


})();
